import { useContext } from 'react'
import { ReactReduxContext } from 'react-redux'
import { createActions } from 'reduxsauce'

// Utility type to convert camelCase to SCREAMING_SNAKE_CASE
type ToScreamingSnakeCase<T extends string> = T extends `${infer First}${infer Rest}`
  ? `${First extends Capitalize<First> ? '_' : ''}${Lowercase<First>}${ToScreamingSnakeCase<Rest>}`
  : ''

export const createTypedActions = <T extends string>(actions: Record<T, string[]>) =>
  createActions<Record<Uppercase<ToScreamingSnakeCase<T>>, string>, Record<T, (...args: any[]) => any>>(actions)

// this is replacement for useDispatch that ensures accessing dispatch doesn't throw an error
// it is useful in cases where the component is not wrapped in a Redux Provider
export const useSanitisedDispatch = () => {
  const context = useContext(ReactReduxContext)

  if (context?.store) {
    return context.store.dispatch
  }

  return () => {
    console.warn('Redux provider not available')
  }
}
